import { useCallback, useEffect, useMemo, useState } from 'react';
import { UserNamesTableResultType } from 'src/types/services/user-service.type';
import { userService } from '../services';

const useGetUsers = () => {
  const [usersList, setUsersList] = useState<UserNamesTableResultType[]>([]);

  const fetchUsers = useCallback(async () => {
    const userResponse = await userService.lookupUsersNameTable({
      blockSpinner: true,
    });
    setUsersList(userResponse.data);
  }, []);

  return useMemo(() => ({ usersList, fetchUsers }), [usersList, fetchUsers]);
};

export default useGetUsers;
